import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M7.5 14h1a.6.6 0 1 1 0 1.2h-1a.6.6 0 1 1 0-1.2Zm4 0h1a.6.6 0 1 1 0 1.2h-1a.6.6 0 1 1 0-1.2Zm5 0h-1a.6.6 0 1 0 0 1.2h1a.6.6 0 1 0 0-1.2Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M20.673 4.638C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311ZM4.2 9.6h15.6v6.6c0 .86 0 1.433-.037 1.873-.035.426-.096.62-.16.744a1.8 1.8 0 0 1-.786.787c-.123.063-.318.124-.744.16-.44.035-1.013.036-1.873.036H7.8c-.86 0-1.433 0-1.873-.037-.426-.035-.62-.096-.744-.16a1.8 1.8 0 0 1-.787-.786c-.063-.123-.124-.318-.16-.744-.035-.44-.036-1.013-.036-1.873V9.6Zm0-1.2h15.6v-.6c0-.86 0-1.433-.037-1.873-.035-.426-.096-.62-.16-.744a1.8 1.8 0 0 0-.786-.787c-.123-.063-.318-.124-.744-.16-.44-.035-1.013-.036-1.873-.036H7.8c-.86 0-1.433 0-1.873.037-.426.035-.62.096-.744.16a1.8 1.8 0 0 0-.787.786c-.063.123-.124.318-.16.744C4.202 6.367 4.2 6.94 4.2 7.8v.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
